<template>
  <div v-loading="loading" class="login">
    <img class="logo" src="https://firebasestorage.googleapis.com/v0/b/operations-60be9.appspot.com/o/p3i_logo.svg?alt=media&token=52d723ec-bb23-44d2-b385-8163f5e3d857"/>
    <el-button v-on:click="signInWithGoogle" type="primary" plain round>Sign In</el-button>
    <!-- <input type="text" v-model="email" placeholder="Email"><br>
    <input type="password" v-model="password" placeholder="Password"><br>
    <button v-on:click="signIn">Connection</button>
    <button v-on:click="signInWithGoogle">Google</button>
    <p>You don't have an account ? You can <router-link to="/sign-up">create one</router-link></p> -->
  </div>
</template>

<script>
  import {auth} from '../main.js'
  import firebase from 'firebase'

  export default {
    name: 'login',
    data: function () {
      return {
        loading: false,
        email: '',
        password: ''
      }
    },
    methods: {
      signIn: function () {
        this.loading = true
        auth.signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            this.$router.replace('dashboard')
          },
          (err) => {
            this.loading = false
            alert('Oops. ' + err.message)
          }
        );
      },
      signInWithGoogle: function () {
        const provider = new firebase.auth.GoogleAuthProvider();
        auth.signInWithRedirect(provider).then((result) => {
          this.user = result.user
        }).catch(err => console.log(err))
      }
    }
  }
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
  .logo {
    width: 300px;
  }
  .login {
    margin-top: 40px;
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center
  }
  input {
    margin: 10px 0;
    width: 20%;
    padding: 15px;
  }
  button {
    margin-top: 20px;
    width: 10%;
    cursor: pointer;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue